/**  Constant to mark each step in the analytics funnel */
export const CURRENT_STEP = 'Current Step';

/** constant to mark last login date */
export const LAST_LOGIN = 'Last Login';

/** Constants to determinate the origin of the Login */
export const DIGITAL_LOGIN = 'Digital';
export const ASSANET_LOGIN = 'Assanet';

/** General Info */
export const LOGGED_ROLE = 'Role';
export const LOGIN_ORIGIN = 'Login Origin';

/** Form Steps */
export const USER_IDENTIFICATION_STEP = 'User Identification Step'; // CustomerPepStep component
export const QUOTATION_CREATED_STEP = 'Quotation Created';
export const COLLECTIVE_SECTION_STEP = 'Collective Selection';
export const TAKER_INFO_STEP = 'Taker Info';
export const AUTO_INFO_STEP = 'Auto Info';

/** Constants for created quotation event */
export const BROKER_LICENSE = 'Broker License';
export const CLIENT_NAME = 'Customer name';
export const CLIENT_GENDER = 'Gender';
export const CLIENT_BIRTHDATE = 'Customer birthdate';
export const CAR_BRAND = 'Car brand';
export const CAR_MODEL = 'Car model';
export const CAR_YEAR = 'Car year';
export const CAR_VALUE = 'Car value';
export const COVERAGE_TYPE = 'Coverage type';
export const PREMIUM = 'Premium';
export const SELECTED_ENDORSMENT = 'Selected endorsment';
export const QUOTATION_DATE = 'Quotation date';
export const CAR_STATE = 'Car state';
export const DEDUCTIBLE_OPTION = 'Deductible option';
export const ID_QUOTATION = 'Id Quotation';
export const PACKAGE_RC = 'Package RC';
export const USER_EMAIL = 'User email';
export const USER_NAME = 'User name';

/** Click events */
export const ITEM_CLICKED = 'Componente';
export const FILE_DOWNLOADED = 'Archivo';
export const THREE_DOTS_MENU = 'Interacción con el menú de tres puntos';
export const SEE_DETAILS_CLICK = 'Ver detalle';
export const MODIFY_VIN_CLICK = 'Modificar vin';
export const DOWNLOAD_DOCUMENTS_CLICK = 'Descargar documentos';
export const COPY_QUOTATION_CLICK = 'Copiar cotización';
export const LIST_CLICK = 'Lista';

export const FILE_MANAGER_EVENT = 'Interacción con menú lateral de documentos';
export const CTA_WHATSAPP_CLICK = 'CTA whatsapp';
export const CTA_CALL_CLICK = 'CTA llamar';
export const CTA_SEND_CLICK = 'CTA enviar';
export const INDIVIDUAL_DOWNLOAD_CLICK = 'Descarga invidivual';
export const ALL_FILES_DOWNLOAD_CLICK = 'Descargar todo';
